import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/index',
  name: 'index',
  component: () => import('../views/index.vue')
},
{
  path: '/index2',
  name: 'index2',
  component: () => import('../views/index2.vue')
},
{
  path: '/productionReport',
  name: 'productionReport',
  component: () => import('../views/productionReport.vue')
},
{
  path: '/',
  name: 'login',
  component: () => import('../views/login/login.vue')
}]
const router = new VueRouter({
  routes
})

export default router

